import MiniHeaders from "./mini-headers";
import {whyWb} from "../data/mock-date";
import React from "react";


const WhyWB = () => {
    return (
        <div>
            <div className={'blocks-wrapper'}>
                <MiniHeaders headerName={'Ինչու՞ հենց Wildberries'}/>
                <ul className="features">
                    {whyWb.map((item, index) => (
                        <li key={index} className="list-item">
                            <span>–</span>
                            <p className="li-item">{item}</p>
                        </li>
                    ))}
                </ul>
                <div className={'why-wb'}/>
            </div>
        </div>
    );
};

export default WhyWB;
